<template>
  <li :class="[entry.type === 'start' ? 'text-teal-darkest' : 'text-indigo-darkest']"
      class="relative flex items-center mr-6 mb-6 rounded bg-white shadow border-teal"
      @mouseover="hover = true"
      @mouseout="hover = false"
  >
    <div class="overflow-hidden flex-no-shrink py-6">
      <div :class="[entry.type === 'start' ? 'bg-teal text-white' : 'bg-indigo text-white']"
           class="w-32 h-32 -ml-8 pt-6 pb-6 pr-2 pl-4 rounded-full"
      >
        <icon-running v-if="entry.type === 'start'" />
        <icon-meditation  v-if="entry.type === 'stop'" />
      </div>
    </div>
    <div class="px-16 py-6">
      <h3 class="uppercase" :class="[entry.type === 'start' ? 'text-teal' : 'text-indigo']">{{ entry.type }}</h3>
      <div class="text-4xl font-thin text-tabular">{{ time }}</div>
    </div>
    <google-map :latitude="entry.latitude"
                :longitude="entry.longitude"
                :color="entry.type === 'start' ? '#4dc0b5' : '#6574cd'"
                class="h-full flex-no-shrink w-48"></google-map>
    <div v-if="hover" @click="deleteEntry" class="delete-button absolute p-1 pin-r pin-t leading-none text-xl cursor-pointer opacity-50 hover:opacity-100">&times;</div>
  </li>
</template>

<script>
import { DateTime } from "luxon";
import GoogleMap from "@/components/GoogleMap";
import IconMeditation from "@/components/IconMeditation";
import IconRunning from "@/components/IconRunning";
import bus from "@/bus";

export default {
  props: ["entry"],

  data: () => ({
    hover: false
  }),

  computed: {
    time() {
      return DateTime.fromISO(this.entry.clickedAt).toLocaleString(
        DateTime.TIME_24_SIMPLE
      );
    }
  },

  components: {
    IconMeditation,
    IconRunning,
    GoogleMap
  },

  methods: {
    deleteEntry() {
      bus.$emit('deleteEntry', this.entry)
    }
  }
};
</script>

<style>
.text-tabular {
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.delete-button {
  transition: all 200ms ease-out;
}
</style>



// WEBPACK FOOTER //
// src/components/Entry.vue